import React from "react";
import Main from "../../Layout/Main";
import Tittle from "../../Components/speaker/Tittle";
import SpeakerSection from "../../Components/speaker/SpeakerSection";
import Call from "../../Components/speaker/Call";
import Client from "../../Components/speaker/Client";
import Subscribe from "../../Components/speaker/Subscribe";

const Speaker = () => {
  return (
    <Main>
      <Tittle />
      <SpeakerSection/>
      <Call/>   
      <Client/>
      <Subscribe/>
    </Main>
  );
};

export default Speaker;
